import React from "react";
import { PropagateLoader } from "react-spinners";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../shad/components/ui/dropdown-menu.jsx";
import { t } from "i18next";
function CommonInputsContainer({
  children,
  onSaveTitle,
  title,
  printIcon,
  menu,
  onSave,
}) {
  const [loading, setLoading] = React.useState(false);

  const onClickSave = async () => {
    setLoading(true);
    await onSave();
    setLoading(false);
  };

  if (loading) return <LoadingForSave />;

  return (
    <div className='flex items-baseline overflow-auto justify-center w-full  bg-[#f9f9f9]'>
      <div className='items-center justify-center w-[80%] h-fit overflow-scroll max-h-[800px] border  bg-white '>
        <div className='flex items-center justify-between w-full p-6 '>
          {menu ? (
            <DropdownMenu>
              <DropdownMenuTrigger>
                <h1 className='text-2xl font-bold'>{title}</h1>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {/* <DropdownMenuLabel>My Account</DropdownMenuLabel>
                <DropdownMenuSeparator /> */}
                {/* <DropdownMenuItem>Profile</DropdownMenuItem>
                <DropdownMenuItem>Billing</DropdownMenuItem>
                <DropdownMenuItem>Team</DropdownMenuItem>
                <DropdownMenuItem>Subscription</DropdownMenuItem> */}
                {menu.map((mn, index) => (
                  <DropdownMenuItem onClick={() => mn.onClick()} key={index}>
                    {t(mn.title)}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <h1 className='text-2xl font-bold'>{title}</h1>
          )}
          <div className='flex items-center'>
            {onSave && (
              <div
                onClick={onClickSave}
                className='p-2 px-8 font-bold text-white bg-red-500 cursor-pointer'>
                {onSaveTitle || t("save")}
              </div>
            )}
            {printIcon ? (
              <div className='w-[100px] mx-2'>{printIcon}</div>
            ) : null}
          </div>
        </div>
        {children}
        <div className='py-7' />
      </div>
    </div>
  );
}

export const LoadingForSave = () => (
  <div className='flex items-center justify-center flex-1 w-full'>
    <PropagateLoader size={40} color='#ff0f0f' />
  </div>
);

export default CommonInputsContainer;
